import { useAsyncData, useNuxtApp } from '#imports'
import { computed } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product-core/composables/useFetch/utils/getOptionalEndpointTimeoutOptions'
import { useDeliveryPostalCode } from '~/scopes/shipping/composables/useDeliveryPostalCode/useDeliveryPostalCode'

import { useFetchPickers } from '../useFetchPickers/useFetchPickers'
import { useFetchProduct } from '../useFetchProduct/useFetchProduct'

export function useFetchShipping() {
  const nuxtApp = useNuxtApp()
  const $httpFetch = useHttpFetch()
  const { postalCode } = useDeliveryPostalCode()
  const productResponse = useFetchProduct()
  const pickersResponse = useFetchPickers()

  const queryParams = computed(() => ({
    zip_code: postalCode.value,
    seller_id: pickersResponse.data.value?.selectedOffer?.merchant?.merchantId,
    category_id: productResponse.data.value?.tracking.categoryId,
  }))

  // Reactive key so a change to any query param (notably the postal code,
  // which is set after mount via localStorage or the modal) produces a new
  // key and triggers a refetch instead of serving the first snapshot.
  const dataKey = computed(() =>
    getAsyncDataKey('pp-shipping', { ...queryParams.value }),
  )

  return useAsyncData(
    dataKey,
    async () => {
      if (
        !queryParams.value.zip_code ||
        !queryParams.value.seller_id ||
        !queryParams.value.category_id
      ) {
        return null
      }

      return $httpFetch('/product-page/shipping/delivery-promise', {
        query: { ...queryParams.value },
      })
    },
    {
      ...getOptionalEndpointTimeoutOptions(),
      dedupe: 'defer',
      watch: [queryParams],
      getCachedData: (key) => nuxtApp.payload.data[key],
    },
  )
}
